import React from "react";
import { services } from "../mock";

function ServiceCard({ service }) {
  return (
    <article className="service-card bg-white overflow-hidden border border-neutral-200">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h4 className="font-display text-xl tracking-wide text-neutral-900">{service.title}</h4>
        {service.subtitle && (
          <p className="text-xs tracking-[0.15em] text-neutral-500 mt-1 uppercase">{service.subtitle}</p>
        )}
        <ul className="mt-4 space-y-2">
          {service.items.map((item) => (
            <li key={item} className="text-neutral-700 text-sm leading-relaxed">
              — {item}
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}

export default function Services() {
  return (
    <section id="services" className="bg-[#fbf3e4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">SERVICES</p>
          <h3 className="font-display text-4xl md:text-6xl leading-[1] text-neutral-900">
            What I offer
          </h3>
          <p className="mt-6 text-neutral-700 text-lg leading-relaxed">
            Every service is tailored to you and your event. Here are the main services I can provide:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
}
